<template>
  <zm-drawer
    @ok="handleSubmit"
    :title="title"
    :width="drawerWidth"
    :visible="visible"
    size="large"
    @cancel="open(false)"
  >
    <div slot="drawerBody">
      <a-form :form="form">
        <div class="title">合同详情</div>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同名称">
              <a-input
                placeholder="请输入合同名称"
                id="name"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true, message: '请输入合同名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同编号">
              <a-input
                placeholder="请输入合同编号"
                id="number"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['number', { rules: [{ required: true, message: '请输入合同编号！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="是否关联销售合同">
              <a-switch
                v-decorator="['relationContractState', { valuePropName: 'checked' }]"
                @change="relationContractStateChange"
                checked-children="是"
                un-checked-children="否"
                :disabled="!isEdit"
              ></a-switch>
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联合同名称">
              <a-select
                placeholder="请选择关联合同名称"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit || !isRelationContractState"
                v-decorator="['contractId', { rules: [{ required: false, message: '请选择关联合同名称！' }] }]"
                @change="contractChange"
              >
                <a-select-option v-for="(option, index) in ContractList" :key="index" :value="option.id">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目名称">
              <a-select
                placeholder="请选择项目名称"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit || isShowProductName"
                v-decorator="['projectId', { rules: [{ required: true, message: '请选择项目名称！' }] }]"
              >
                <a-select-option v-for="(option, index) in ProjectList" :key="index" :value="option.id">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select
                placeholder="请选择供应商"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['supplierId', { rules: [{ required: true, message: '请选择供应商！' }] }]"
              >
                <a-select-option v-for="(option, index) in SupplierList" :key="index" :value="option.id">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内容类型">
              <a-select
                placeholder="请选择内容类型"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['contentType', { rules: [{ required: true, message: '请选择内容类型！' }] }]"
              >
                <a-select-option v-for="(option, index) in ContentTypeList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="签约日期">
              <a-date-picker
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择签约日期"
                v-decorator="['signDate', { rules: [{ required: true, message: '请选择签约日期！' }] }]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="质保期限">
              <a-select
                placeholder="请选择质保期限"
                :disabled="!isEdit"
                v-decorator="['maintainExpires', { rules: [{ required: true, message: '请选择质保期限！' }] }]"
              >
                <a-select-option v-for="(option, index) in MaintainExpiresList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="验收日期">
              <a-date-picker
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择验收日期"
                v-decorator="['checkDate', { rules: [{ required: true, message: '请选择验收日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办人">
              <a-select
                placeholder="请选择经办人"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['operatorId', { rules: [{ required: true, message: '请选择经办人！' }] }]"
              >
                <a-select-option v-for="(option, index) in OperatorList" :key="index" :value="option.id">
                  {{ option.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同金额">
              <a-input
                placeholder="请输入合同金额"
                id="contractAmount"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['contractAmount', { rules: [{ required: true, message: '请输入合同金额！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider style="margin: 16px 0"></a-divider>

        <div class="title">采购物品信息</div>
        <!-- 此处循环 -->
        <purchase-modal
          ref="purchaseModal"
          :arr="model.inquiryProductList"
          :InquiryList="InquiryList"
          :UnitList="UnitList"
          :form="form"
          :type="type"
        ></purchase-modal>

        <a-divider style="margin: 16px 0"></a-divider>

        <div class="title">付款方式</div>
        <!-- 此处循环 -->
        <payments-modal
          ref="paymentsModal"
          :arr="model.payments"
          :PaymentTypeList="PaymentTypeList"
          :form="form"
          :type="type"
        ></payments-modal>
        <a-divider style="margin: 16px 0"></a-divider>
        <div class="title">附件上传</div>
        <a-row>
          <a-col :span="24">
            <a-form-item
              label="合同附件"
              :labelCol="{ xs: { span: 24 }, sm: { span: 2 } }"
              :wrapperCol="{ xs: { span: 24 }, sm: { span: 22 } }"
            >
              <zm-upload
                v-if="isShow"
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                acceptType="pdf"
                @handleUpload="handleUpload"
                v-decorator="['uploader', { rules: [{ required: true, message: '请上传文件或等待上传成功！' }] }]"
              ></zm-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { getSaleList } from '@/api/sale'
import { getProjectList } from '@/api/project'
import { getSupplierList } from '@/api/supplier'
import { getUserBaseInfo } from '@/api/baseInfo'
import { getDictInfoByCode } from '@/api/dict'
import { getInquiryList } from '@/api/inquiry'
import { insertPurchases } from '@/api/purchases'
import purchaseModal from './loopModal/purchaseModal.vue'
import paymentsModal from './loopModal/paymentsModal.vue'
export default {
  name: 'editPurchases',
  mounted() {
    this.getSelectContractList()
    this.getSelectProjectList()
    this.getSelectSupplierList()
    this.getSelectContentTypeList()
    this.getSelectMaintainExpiresList()
    this.getSelectOperatorList()
    this.getSelectInquiryList()
    this.getSelectUnitList()
    this.getSelectPaymentTypeList()
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth() {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({}),
  },
  components: {
    purchaseModal,
    paymentsModal,
  },
  data() {
    return {
      ContractList: [],
      ProjectList: [],
      SupplierList: [],
      ContentTypeList: [],
      MaintainExpiresList: [],
      OperatorList: [],
      InquiryList: [],
      UnitList: [],
      PaymentTypeList: [],
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'purchases' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      colSpan: 6,
      headers: {
        Authorization: this.$store.state.user.token,
      },
      fileList: [],
      //是否关联销售合同
      isRelationContractState: null,
      //是否禁用项目名称
      isShowProductName:null,
      //v-if销毁组件
      isShow:true
    }
  },
  methods: {
    // 设置类型
    setType(type) {
      this.type = type
    },
    // 设置标题
    setTitle(title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      this.visible = flag
      this.isShow = flag
      if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
        if (flag) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              name: this.model.name,
              number: this.model.number,
              relationContractState: this.model.relationContractState,
              contractId: this.model.contractId,
              projectId: this.model.projectId,
              supplierId: this.model.supplierId,
              contentType: this.model.contentType,
              signDate: moment(this.model.signDate),
              maintainExpires: this.model.maintainExpires,
              checkDate: moment(this.model.signDate),
              operatorId: this.model.operatorId,
              contractAmount: this.model.contractAmount,
            })
          })
          //编辑时初始化关联bool
          this.isRelationContractState = this.model.relationContractState
          //编辑时初始化禁用项目名称bool
          this.isShowProductName = this.model.relationContractState
          this.fileList = this.model.files
        }
      } else {
        this.formClear()
      }
      //初始化loop组件(动画结束后调用，不然丑)
      setTimeout(() => {
        this.$refs.purchaseModal.init()
        this.$refs.paymentsModal.init()
      }, 200);
    },
    // 提交表单
    handleSubmit() {
      //没上传或还在上传，则不给字段赋值，则会通知校验
      if(this.fileList.length != 0){
        this.form.setFieldsValue({
          uploader:"随便给个值"
        })
      }else{
        
      }
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const inquiryProductList = this.$refs.purchaseModal.getData()
          const payments = this.$refs.paymentsModal.getData()

          const data = {
            name:value.name,
            number:value.number,
            relationContractState:value.relationContractState ? 1 : 0,
            projectId:value.projectId,
            supplierId:value.supplierId,
            contentType:value.contentType,
            signDate:moment(value.signDate).format('YYYY-MM-DD'),
            maintainExpires:value.maintainExpires,
            checkDate:moment(value.checkDate).format('YYYY-MM-DD'),
            operatorId:value.operatorId,
            operatorName:this.OperatorList.filter(item => item.id === value.operatorId)[0].userName,
            contractAmount:value.contractAmount,
            inquiryProductList,
            payments,
            files:this.fileList,
          }

          console.log('处理过的数据！！！',data);


          const params = { id:this.model.id, ...data }
          if (this.type === this.$sysInfo.MODAL_ADD) {
            delete params.id
            const res = await insertPurchases(params).catch((error) => {
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            const res = await insertPurchases(params).catch((error) => {
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          }
        }
      })
    },
    // 获取当前的model详情

    handleChange() {},
    // 清空表单
    formClear() {
      this.$nextTick(() => {
        this.model = {}
        this.form.resetFields()
      })
      if(this.$refs.uploader){
        this.$refs.uploader.clearFileList()
      }
      this.fileList = []
      //新增时初始化关联bool
      this.isRelationContractState = false
      //新增时初始化禁用项目名称bool
      this.isShowProductName = false
    },
    cancel() {
      this.formClear()
      this.open(false)
    },
    //交互时 改变关联bool 改变禁用项目名称bool
    relationContractStateChange(value) {
      console.log('关联状态：', value)
      if(!value){
        this.form.setFieldsValue({
          contractId:undefined
        })
      }
      this.isRelationContractState = value
      this.isShowProductName = value
    },
    //监听销售合同改变 
    contractChange(id) {
      console.log('打印合同id','id', id)
      const obj = this.ContractList.filter((item) => item.id === id)[0]
      console.log('打印更新数据', obj)
      this.form.setFieldsValue({
        projectId: obj.projectId,
        maintainExpires: obj.maintainDeadLineDesc,
        operatorId: obj.operatorId,
      })
    },
    //文件列表获取
    handleUpload(fileList) {
      this.fileList = fileList
    },
    //销售合同列表
    getSelectContractList() {
      getSaleList({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.ContractList = res.data
          console.log('this.ContractList', this.ContractList)
        }
      })
    },
    //项目列表
    getSelectProjectList() {
      getProjectList({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.ProjectList = res.data
        }
      })
    },
    //供应商列表
    getSelectSupplierList() {
      getSupplierList({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.SupplierList = res.data
        }
      })
    },
    //内容类型
    getSelectContentTypeList() {
      getDictInfoByCode({ pCode: 'CONTRACT_CONTENT_TYPE' }).then((res) => {
        if (res.status === 0) {
          this.ContentTypeList = res.data
        }
      })
    },
    //质保期限
    getSelectMaintainExpiresList() {
      getDictInfoByCode({ pCode: 'MAINTAIN_DEADLINE' }).then((res) => {
        if (res.status === 0) {
          this.MaintainExpiresList = res.data
        }
      })
    },
    //经办人列表
    getSelectOperatorList() {
      getUserBaseInfo({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.OperatorList = res.data
        }
      })
    },
    //采购物品列表
    getSelectInquiryList() {
      getInquiryList({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.InquiryList = res.data
        }
      })
    },
    //单位列表
    getSelectUnitList() {
      getDictInfoByCode({ pCode: 'PRODUCT_UNIT' }).then((res) => {
        if (res.status === 0) {
          this.UnitList = res.data
        }
      })
    },
    //款项类型列表
    getSelectPaymentTypeList() {
      getDictInfoByCode({ pCode: 'PAYMENT_TYPE' }).then((res) => {
        if (res.status === 0) {
          this.PaymentTypeList = res.data
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
.title {
  font-weight: bold;
  margin-bottom: 10px;
}
.title::before {
  display: inline-block;
  width: 4px;
  height: 12px;
  background: #1791ff;
  content: '';
  margin-right: 7px;
}
</style>

